import { render, staticRenderFns } from "./ExcTickerLogosBlock_new.vue?vue&type=template&id=16d79cc0&scoped=true&"
import script from "./ExcTickerLogosBlock_new.vue?vue&type=script&lang=js&"
export * from "./ExcTickerLogosBlock_new.vue?vue&type=script&lang=js&"
import style0 from "./ExcTickerLogosBlock_new.vue?vue&type=style&index=0&id=16d79cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d79cc0",
  null
  
)

export default component.exports